import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, Shield, Truck, CreditCard, Users, UserPlus } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/madeinbd-logo.png" 
                alt="Made in BD" 
                className="h-8 sm:h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Leading B2B marketplace connecting international buyers with verified Bangladeshi suppliers. 
              Discover premium export-quality products with secure transactions and reliable shipping.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Product Categories */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Export Categories</h4>
            <ul className="space-y-2">
              <li><Link to="/category/garments-apparel" className="text-gray-300 hover:text-white transition-colors">Garments & Apparel</Link></li>
              <li><Link to="/category/jute-natural-fiber" className="text-gray-300 hover:text-white transition-colors">Jute & Natural Fiber</Link></li>
              <li><Link to="/category/frozen-foods" className="text-gray-300 hover:text-white transition-colors">Frozen Foods</Link></li>
              <li><Link to="/category/leather-goods" className="text-gray-300 hover:text-white transition-colors">Leather Goods</Link></li>
              <li><Link to="/category/pharmaceuticals-health" className="text-gray-300 hover:text-white transition-colors">Pharmaceuticals</Link></li>
              <li><Link to="/category/scrap-recycling" className="text-gray-300 hover:text-white transition-colors">Scrap & Recycling</Link></li>
            </ul>
          </div>

          {/* B2B Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">B2B Services</h4>
            <ul className="space-y-2">
              <li><Link to="/services/escrow" className="text-gray-300 hover:text-white transition-colors flex items-center space-x-2">
                <Shield className="h-4 w-4 text-emerald-400" />
                <span>Escrow Service</span>
              </Link></li>
              <li><Link to="/services/pre-shipment" className="text-gray-300 hover:text-white transition-colors flex items-center space-x-2">
                <Truck className="h-4 w-4 text-blue-400" />
                <span>Pre-shipment Inspection</span>
              </Link></li>
              <li><Link to="/services/buy-for-me" className="text-gray-300 hover:text-white transition-colors flex items-center space-x-2">
                <CreditCard className="h-4 w-4 text-purple-400" />
                <span>Buy For Me Service</span>
              </Link></li>
              <li><Link to="/services/buyer-support" className="text-gray-300 hover:text-white transition-colors flex items-center space-x-2">
                <Users className="h-4 w-4 text-orange-400" />
                <span>Buyer Support</span>
              </Link></li>
              <li><Link to="/suppliers" className="text-gray-300 hover:text-white transition-colors flex items-center space-x-2">
                <UserPlus className="h-4 w-4 text-green-400" />
                <span>Become Supplier</span>
              </Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300">57/8, Ground floor, East Rajabzar, West Panthapath, Dhaka 1215, Bangladesh.</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-emerald-400 flex-shrink-0" />
                <span className="text-gray-300">+88 01770 156 736</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-emerald-400 flex-shrink-0" />
                <span className="text-gray-300">hello@madeinbd.com</span>
              </div>
            </div>
            
            {/* Quick Links */}
            <div className="mt-6">
              <h5 className="text-md font-medium mb-3">Quick Links</h5>
              <ul className="space-y-1 text-sm">
                <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
                <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
                <li><Link to="/help" className="text-gray-300 hover:text-white transition-colors">Help Center</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 Made in BD. All rights reserved. Connecting Bangladesh with the world through B2B excellence.
            </div>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link>
              <Link to="/shipping" className="text-gray-400 hover:text-white transition-colors">Shipping Info</Link>
              <Link to="/export-guidelines" className="text-gray-400 hover:text-white transition-colors">Export Guidelines</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;